import { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { DesktopLayout } from 'src/layout';
import IntentService from 'src/services/IntentService';
import { clearIntentHandoff, readIntentHandoff } from 'src/utils/intentHandoff';
import LeadStreamScreen from 'src/screens/LeadStream';

export default function FlowLaunchEntry() {
    const { search } = useLocation();
    const flow = new URLSearchParams(search).get('draft') || new URLSearchParams(search).get('flow');
    const [token, setToken] = useState(() => (flow ? null : readIntentHandoff('draft')));
    const [destination, setDestination] = useState('');
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        if (!token || flow) return;
        let live = true;
        setError(false);
        IntentService.claimDraft(token)
            .then((draft) => {
                if (!live) return;
                clearIntentHandoff('draft', token);
                setDestination('/leadstream?draft=' + draft.id);
            })
            .catch(() => {
                if (live) setError(true);
            });
        return () => {
            live = false;
        };
    }, [token, attempt, flow]);
    if (destination && !flow) return <Redirect to={destination} />;
    if (token && !flow)
        return (
            <DesktopLayout>
                <Box sx={{ maxWidth: 620, mx: 'auto', py: 6 }}>
                    {error ? (
                        <Alert severity="warning">
                            Не удалось перенести описание с сайта. Попробуйте ещё раз.
                            <Stack
                                direction="row"
                                spacing={1}
                                mt={1}
                            >
                                <Button onClick={() => setAttempt((value) => value + 1)}>Повторить</Button>
                                <Button
                                    color="inherit"
                                    onClick={() => {
                                        clearIntentHandoff('draft', token);
                                        setToken(null);
                                    }}
                                >
                                    Заполнить заново
                                </Button>
                            </Stack>
                        </Alert>
                    ) : (
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                            role="status"
                        >
                            <CircularProgress size={22} />
                            <Typography>Переносим описание с сайта…</Typography>
                        </Stack>
                    )}
                </Box>
            </DesktopLayout>
        );
    // A different flow must restore its own form and category selection.
    return <LeadStreamScreen key={flow || 'new'} />;
}
